"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberValidatorCreator = void 0;
const FormValidatorDecoratorService_1 = require("./FormValidatorDecoratorService");
const LocalizedThresholdValidatorFn_1 = require("./LocalizedThresholdValidatorFn");
const LocalizedRangeValidatorFn_1 = require("./LocalizedRangeValidatorFn");
const FormErrorMessages_1 = require("./FormErrorMessages");
/**
 * Internal Implementation of the NumberValidatorCreator
 */
class _NumberValidatorCreator {
    constructor() { }
    /**
     * Creates a validator that returns true if the input value <= the given threshold.
     *
     * @param
     *
     *  options
     * threshold The threshold that is used for comparison.
     * isRequired True if the input is required. Empty input is invalid if the input is required.
     * locale The locale that is used to interpret the number string.
     * errorMessage Function that returns an error message for the given validation result, that is intended for the UI.
     * If no function is provided, then the default error message function from the FormErrorMessageProvider is used.
     * roundType The round type that should be applied during the round operation.
     * The default round type is ROUND.
     * precision The desired number of digits after the decimal point that the rounded value should have.
     * The default value is 0.
     * significantPrecision The number of digits after the decimal point that are considered during rounding.
     * The default value is equal to precision + 1.
     * @returns Returns the validator.
     */
    createLessEqualValidator(options) {
        const errorKeys = LocalizedThresholdValidatorFn_1.localizedThresholdValidatorErrorKeys;
        let validator = ((input) => {
            const controlValue = input.value;
            // Check if control has value
            if (!controlValue && controlValue !== 0) {
                if (validator.isRequired) {
                    return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.REQUIRED]: true };
                }
                else {
                    return null;
                }
            }
            const valueAsNumber = validator.toNumber(input.value);
            if (!valueAsNumber && valueAsNumber !== 0) {
                return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.PARSE]: true };
            }
            if (!(valueAsNumber <= validator.threshold)) {
                return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.THRESHOLD]: validator.threshold };
            }
            return null;
        });
        validator.threshold = options.threshold;
        validator.isRequired = options.isRequired;
        validator.type = LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorType.LESS_EQUAL;
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToObservableValidator(validator, {
            errorKeys,
            errorMessage: options.errorMessage ? options.errorMessage : FormErrorMessages_1.formErrorMessages.errorMessageThresholdValidator(),
        });
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToLocalizedNumberValidator(validator, {
            locale: options.locale,
            roundType: options.roundType,
            precision: options.precision,
            significantPrecision: options.significantPrecision,
        });
        return validator;
    }
    /**
     * Creates a validator that returns true if the input value < the given threshold.
     *
     * @param
     *
     *
     *
     *
     *
     *
     *
     *  options
     * threshold The threshold that is used for comparison.
     * isRequired True if the input is required. Empty input is invalid if the input is required.
     * locale The locale that is used to interpret the number string.
     * errorMessage Function that returns an error message for the given validation result, that is intended for the UI.
     * If no function is provided, then the default error message function from the FormErrorMessageProvider is used.
     * roundType The round type that should be applied during the round operation.
     * The default round type is ROUND.
     * precision The desired number of digits after the decimal point that the rounded value should have.
     * The default value is 0.
     * significantPrecision The number of digits after the decimal point that are considered during rounding.
     * The default value is equal to precision + 1.
     * @returns Returns the validator.
     */
    createLessValidator(options) {
        const errorKeys = LocalizedThresholdValidatorFn_1.localizedThresholdValidatorErrorKeys;
        let validator = ((input) => {
            const controlValue = input.value;
            // Check if control has value
            if (!controlValue && controlValue !== 0) {
                if (validator.isRequired) {
                    return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.REQUIRED]: true };
                }
                else {
                    return null;
                }
            }
            const valueAsNumber = validator.toNumber(input.value);
            if (!valueAsNumber && valueAsNumber !== 0) {
                return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.PARSE]: true };
            }
            if (!(valueAsNumber < validator.threshold)) {
                return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.THRESHOLD]: validator.threshold };
            }
            return null;
        });
        validator.threshold = options.threshold;
        validator.isRequired = options.isRequired;
        validator.type = LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorType.LESS;
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToObservableValidator(validator, {
            errorKeys,
            errorMessage: options.errorMessage ? options.errorMessage : FormErrorMessages_1.formErrorMessages.errorMessageThresholdValidator(),
        });
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToLocalizedNumberValidator(validator, {
            locale: options.locale,
            roundType: options.roundType,
            precision: options.precision,
            significantPrecision: options.significantPrecision,
        });
        return validator;
    }
    /**
     * Creates a validator that returns true if the input value >= the given threshold.
     *
     * @param
     *
     *
     *
     *
     *
     *
     *
     *  options
     * threshold The threshold that is used for comparison.
     * thresholdFunc The function to overwrite the threshold which is used for comparison.
     * isRequired True if the input is required. Empty input is invalid if the input is required.
     * locale The locale that is used to interpret the number string.
     * errorMessage Function that returns an error message for the given validation result, that is intended for the UI.
     * If no function is provided, then the default error message function from the FormErrorMessageProvider is used.
     * roundType The round type that should be applied during the round operation.
     * The default round type is ROUND.
     * precision The desired number of digits after the decimal point that the rounded value should have.
     * The default value is 0.
     * significantPrecision The number of digits after the decimal point that are considered during rounding.
     * The default value is equal to precision + 1.
     * @returns Returns the validator.
     */
    createGreaterEqualValidator(options) {
        const errorKeys = LocalizedThresholdValidatorFn_1.localizedThresholdValidatorErrorKeys;
        let validator = ((input) => {
            const controlValue = input.value;
            // Check if control has value
            if (!controlValue && controlValue !== 0) {
                if (validator.isRequired) {
                    return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.REQUIRED]: true };
                }
                else {
                    return null;
                }
            }
            const valueAsNumber = validator.toNumber(input.value);
            if (!valueAsNumber && valueAsNumber !== 0) {
                return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.PARSE]: true };
            }
            const thresholdValue = typeof validator.threshold === 'function' ? validator.threshold() : validator.threshold;
            if (!(valueAsNumber >= thresholdValue)) {
                return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.THRESHOLD]: thresholdValue };
            }
            return null;
        });
        validator.threshold = options.threshold;
        validator.isRequired = options.isRequired;
        validator.type = LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorType.GREATER_EQUAL;
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToObservableValidator(validator, {
            errorKeys,
            errorMessage: options.errorMessage ? options.errorMessage : FormErrorMessages_1.formErrorMessages.errorMessageThresholdValidator(),
        });
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToLocalizedNumberValidator(validator, {
            locale: options.locale,
            roundType: options.roundType,
            precision: options.precision,
            significantPrecision: options.significantPrecision,
        });
        return validator;
    }
    /**
     * Creates a validator that returns true if the input value > the given threshold.
     *
     * @param
     *
     *
     *
     *
     *
     *
     *
     *  options
     * threshold The threshold that is used for comparison.
     * isRequired True if the input is required. Empty input is invalid if the input is required.
     * locale The locale that is used to interpret the number string.
     * errorMessage Function that returns an error message for the given validation result, that is intended for the UI.
     * If no function is provided, then the default error message function from the FormErrorMessageProvider is used.
     * roundType The round type that should be applied during the round operation.
     * The default round type is ROUND.
     * precision The desired number of digits after the decimal point that the rounded value should have.
     * The default value is 0.
     * significantPrecision The number of digits after the decimal point that are considered during rounding.
     * The default value is equal to precision + 1.
     * @returns Returns the validator.
     */
    createGreaterValidator(options) {
        const errorKeys = LocalizedThresholdValidatorFn_1.localizedThresholdValidatorErrorKeys;
        let validator = ((input) => {
            const controlValue = input.value;
            // Check if control has value
            if (!controlValue && controlValue !== 0) {
                if (validator.isRequired) {
                    return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.REQUIRED]: true };
                }
                else {
                    return null;
                }
            }
            const valueAsNumber = validator.toNumber(input.value);
            if (!valueAsNumber && valueAsNumber !== 0) {
                return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.PARSE]: true };
            }
            if (!(valueAsNumber > validator.threshold)) {
                return { [LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.THRESHOLD]: validator.threshold };
            }
            return null;
        });
        validator.threshold = options.threshold;
        validator.isRequired = options.isRequired;
        validator.type = LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorType.GREATER;
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToObservableValidator(validator, {
            errorKeys,
            errorMessage: options.errorMessage ? options.errorMessage : FormErrorMessages_1.formErrorMessages.errorMessageThresholdValidator(),
        });
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToLocalizedNumberValidator(validator, {
            locale: options.locale,
            roundType: options.roundType,
            precision: options.precision,
            significantPrecision: options.significantPrecision,
        });
        return validator;
    }
    /**
     * Creates a validator that returns true if the input value >= the given thresholdMin and <= the given thresholdMax.
     *
     * @param
     *
     *
     *
     *
     *
     *
     *
     *
     *  options
     * thresholdMin The lower threshold that is used for comparison.
     * thresholdMax The upper threshold that is used for comparison.
     * isRequired True if the input is required. Empty input is invalid if the input is required.
     * locale The locale that is used to interpret the number string.
     * errorMessage Function that returns an error message for the given validation result, that is intended for the UI.
     * If no function is provided, then the default error message function from the FormErrorMessageProvider is used.
     * roundType The round type that should be applied during the round operation.
     * The default round type is ROUND.
     * precision The desired number of digits after the decimal point that the rounded value should have.
     * The default value is 0.
     * significantPrecision The number of digits after the decimal point that are considered during rounding.
     * The default value is equal to precision + 1.
     * @returns Returns the validator.
     */
    createGreaterEqualMinLessEqualMaxValidator(options) {
        const errorKeys = LocalizedRangeValidatorFn_1.localizedRangeValidatorErrorKeys;
        let validator = ((input) => {
            const controlValue = input.value;
            // Check if control has value
            if (!controlValue && controlValue !== 0) {
                if (validator.isRequired) {
                    return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.REQUIRED]: true };
                }
                else {
                    return null;
                }
            }
            // Allow writing negative values
            if (controlValue === '-') {
                return null;
            }
            const valueAsNumber = validator.toNumber(input.value);
            if (!valueAsNumber && valueAsNumber !== 0) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.PARSE]: true };
            }
            if (valueAsNumber < validator.thresholdMin) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MIN]: validator.thresholdMin };
            }
            if (valueAsNumber > validator.thresholdMax) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MAX]: validator.thresholdMax };
            }
            return null;
        });
        validator.thresholdMin = options.thresholdMin;
        validator.thresholdMax = options.thresholdMax;
        validator.isRequired = options.isRequired;
        validator.type = LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_EQUAL_MIN_LESS_EQUAL_MAX;
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToObservableValidator(validator, {
            errorKeys,
            errorMessage: options.errorMessage ? options.errorMessage : FormErrorMessages_1.formErrorMessages.errorMessageRangeValidator(),
        });
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToLocalizedNumberValidator(validator, {
            locale: options.locale,
            roundType: options.roundType,
            precision: options.precision,
            significantPrecision: options.significantPrecision,
        });
        return validator;
    }
    /**
     * Creates a validator that returns true if the input value >= the given thresholdMin and < the given thresholdMax.
     *
     * @param
     *
     *
     *
     *
     *
     *
     *
     *
     *  options
     * thresholdMin The lower threshold that is used for comparison.
     * thresholdMax The upper threshold that is used for comparison.
     * isRequired True if the input is required. Empty input is invalid if the input is required.
     * locale The locale that is used to interpret the number string.
     * errorMessage Function that returns an error message for the given validation result, that is intended for the UI.
     * If no function is provided, then the default error message function from the FormErrorMessageProvider is used.
     * roundType The round type that should be applied during the round operation.
     * The default round type is ROUND.
     * precision The desired number of digits after the decimal point that the rounded value should have.
     * The default value is 0.
     * significantPrecision The number of digits after the decimal point that are considered during rounding.
     * The default value is equal to precision + 1.
     * @returns Returns the validator.
     */
    createGreaterEqualMinLessMaxValidator(options) {
        const errorKeys = LocalizedRangeValidatorFn_1.localizedRangeValidatorErrorKeys;
        let validator = ((input) => {
            const controlValue = input.value;
            // Check if control has value
            if (!controlValue && controlValue !== 0) {
                if (validator.isRequired) {
                    return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.REQUIRED]: true };
                }
                else {
                    return null;
                }
            }
            const valueAsNumber = validator.toNumber(input.value);
            if (!valueAsNumber && valueAsNumber !== 0) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.PARSE]: true };
            }
            if (valueAsNumber < validator.thresholdMin) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MIN]: validator.thresholdMin };
            }
            if (valueAsNumber >= validator.thresholdMax) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MAX]: validator.thresholdMax };
            }
            return null;
        });
        validator.thresholdMin = options.thresholdMin;
        validator.thresholdMax = options.thresholdMax;
        validator.isRequired = options.isRequired;
        validator.type = LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_EQUAL_MIN_LESS_MAX;
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToObservableValidator(validator, {
            errorKeys,
            errorMessage: options.errorMessage ? options.errorMessage : FormErrorMessages_1.formErrorMessages.errorMessageRangeValidator(),
        });
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToLocalizedNumberValidator(validator, {
            locale: options.locale,
            roundType: options.roundType,
            precision: options.precision,
            significantPrecision: options.significantPrecision,
        });
        return validator;
    }
    /**
     * Creates a validator that returns true if the input value > the given thresholdMin and <= the given thresholdMax.
     *
     * @param
     *
     *
     *
     *
     *
     *
     *
     *
     *  options
     * thresholdMin The lower threshold that is used for comparison.
     * thresholdMax The upper threshold that is used for comparison.
     * isRequired True if the input is required. Empty input is invalid if the input is required.
     * locale The locale that is used to interpret the number string.
     * errorMessage Function that returns an error message for the given validation result, that is intended for the UI.
     * If no function is provided, then the default error message function from the FormErrorMessageProvider is used.
     * roundType The round type that should be applied during the round operation.
     * The default round type is ROUND.
     * precision The desired number of digits after the decimal point that the rounded value should have.
     * The default value is 0.
     * significantPrecision The number of digits after the decimal point that are considered during rounding.
     * The default value is equal to precision + 1.
     * @returns Returns the validator.
     */
    createGreaterMinLessEqualMaxValidator(options) {
        const errorKeys = LocalizedRangeValidatorFn_1.localizedRangeValidatorErrorKeys;
        let validator = ((input) => {
            const controlValue = input.value;
            // Check if control has value
            if (!controlValue && controlValue !== 0) {
                if (validator.isRequired) {
                    return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.REQUIRED]: true };
                }
                else {
                    return null;
                }
            }
            const valueAsNumber = validator.toNumber(input.value);
            if (!valueAsNumber && valueAsNumber !== 0) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.PARSE]: true };
            }
            if (valueAsNumber <= validator.thresholdMin) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MIN]: validator.thresholdMin };
            }
            if (valueAsNumber > validator.thresholdMax) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MAX]: validator.thresholdMax };
            }
            return null;
        });
        validator.thresholdMin = options.thresholdMin;
        validator.thresholdMax = options.thresholdMax;
        validator.isRequired = options.isRequired;
        validator.type = LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_MIN_LESS_EQUAL_MAX;
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToObservableValidator(validator, {
            errorKeys,
            errorMessage: options.errorMessage ? options.errorMessage : FormErrorMessages_1.formErrorMessages.errorMessageRangeValidator(),
        });
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToLocalizedNumberValidator(validator, {
            locale: options.locale,
            roundType: options.roundType,
            precision: options.precision,
            significantPrecision: options.significantPrecision,
        });
        return validator;
    }
    /**
     * Creates a validator that returns true if the input value > the given thresholdMin and < the given thresholdMax.
     *
     * @param
     *
     *
     *
     *
     *
     *
     *
     *
     *  options
     * thresholdMin The lower threshold that is used for comparison.
     * thresholdMax The upper threshold that is used for comparison.
     * isRequired True if the input is required. Empty input is invalid if the input is required.
     * locale The locale that is used to interpret the number string.
     * errorMessage Function that returns an error message for the given validation result, that is intended for the UI.
     * If no function is provided, then the default error message function from the FormErrorMessageProvider is used.
     * roundType The round type that should be applied during the round operation.
     * The default round type is ROUND.
     * precision The desired number of digits after the decimal point that the rounded value should have.
     * The default value is 0.
     * significantPrecision The number of digits after the decimal point that are considered during rounding.
     * The default value is equal to precision + 1.
     * @returns Returns the validator.
     */
    createGreaterMinLessMaxValidator(options) {
        const errorKeys = LocalizedRangeValidatorFn_1.localizedRangeValidatorErrorKeys;
        let validator = ((input) => {
            const controlValue = input.value;
            // Check if control has value
            if (!controlValue && controlValue !== 0) {
                if (validator.isRequired) {
                    return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.REQUIRED]: true };
                }
                else {
                    return null;
                }
            }
            const valueAsNumber = validator.toNumber(input.value);
            if (!valueAsNumber && valueAsNumber !== 0) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.PARSE]: true };
            }
            if (valueAsNumber <= validator.thresholdMin) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MIN]: validator.thresholdMin };
            }
            if (valueAsNumber >= validator.thresholdMax) {
                return { [LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MAX]: validator.thresholdMax };
            }
            return null;
        });
        validator.thresholdMin = options.thresholdMin;
        validator.thresholdMax = options.thresholdMax;
        validator.isRequired = options.isRequired;
        validator.type = LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_MIN_LESS_MAX;
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToObservableValidator(validator, {
            errorKeys,
            errorMessage: options.errorMessage ? options.errorMessage : FormErrorMessages_1.formErrorMessages.errorMessageRangeValidator(),
        });
        validator = FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToLocalizedNumberValidator(validator, {
            locale: options.locale,
            roundType: options.roundType,
            precision: options.precision,
            significantPrecision: options.significantPrecision,
        });
        return validator;
    }
}
/**
 * The exported validator creator instance.
 *
 * @type {NumberValidatorCreator}
 */
exports.numberValidatorCreator = new _NumberValidatorCreator();
//# sourceMappingURL=NumberValidatorCreator.js.map